import { useCallback, useMemo } from 'react';
import {
	Tooth,
	ToothEndodontic,
	ToothEndodonticInput,
	ToothEndodonticTestInput,
} from '../../../../../graphql/graphql';
import { useDENTContext } from '../../../Services/DENTContext';

export default function useToothEndodontic() {
	const { activeTooth, setActiveTooth } = useDENTContext();
	const endodontic = activeTooth?.endodontic;

	const setEndodontic = useCallback(
		(endodontic: ToothEndodontic) => {
			setActiveTooth((prev: Tooth | undefined) => {
				if (!prev) return prev;

				return {
					...prev,
					endodontic,
				};
			});
		},
		[setActiveTooth],
	);

	const getEndodonticInput = useMemo((): ToothEndodonticInput => {
		if (!endodontic) return {};

		const convertTest = (test: any): ToothEndodonticTestInput | undefined => {
			if (!test?.result) return undefined;
			return {
				result: test.result,
				resultPositive: test.resultPositive,
				resultNotApplicable: test.resultNotApplicable,
			};
		};

		return {
			cold: convertTest(endodontic.cold),
			heat: convertTest(endodontic.heat),
			electric: endodontic.electric,
			percussion: endodontic.percussion,
			palpation: endodontic.palpation,
		};
	}, [endodontic]);

	return useMemo(
		() => ({
			endodontic: {
				getEndodontic: getEndodonticInput,
				setEndodontic,
			},
		}),
		[activeTooth, endodontic, getEndodonticInput],
	);
}
